import styled from 'styled-components';

export const LoaderWrapperStyled = styled.div`
    position: relative;
    height: 200px;
`;
